<template>
    <div>
        <h6 class="text-right mt-5 mb-0"><i class="fas fa-filter"></i>FILTROS</h6>
        <div class="d-flex justify-content-end mb-1">
            <div>
                <vs-input v-model="filtro_texto" @input="getFiltrarTexto(filtro_texto)" placeholder="Buscar">
                    <template #icon>
                    <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </div>
            <div class="d-flex">
                <vs-checkbox v-for="(filtro, f) in filtros" :key="'f' + f" v-model="filtro.valor" @change="getFiltros(true)"  color="#34495E">
                    {{filtro.nombre}}
                </vs-checkbox>
            </div>
        </div>
        <div class="mt-1 borderTarjeta p-2" v-if="alumnosFiltro">
            <p class="sinInfo" v-if="!alumnosFiltro[0]">Sin información</p>
            <div 
                :key="i"
                v-for="(tr, i) in alumnosFiltro"
                v-else
            >
                <fila-alumnos :tr="tr" :index="i"></fila-alumnos>
            </div> 
        </div>
    </div>
</template>

<script>
import FilaAlumnos from './detalles.vue'
export default {
    props: [
        'programa',
        'filtrosGenerales',
        'posicion_ciclo',
        'posicion_programa'
    ],
    data(){
        return{
            filtros: [
                {
                    nombre: 'Alumnos con pago de inscripción',
                    tipo: 'cuenta_con_pago_inscripcion',
                    valor: false
                },
                {
                    nombre: 'Alumnos con beca',
                    tipo: 'cuenta_con_beca',
                    valor: false
                },
                {
                    nombre: 'Alumnos con registro académico',
                    tipo: 'cuenta_con_registro_academico',
                    valor: false
                }
            ],
            filtro_texto: '',
            alumnosFiltro: this.programa.alumnos,
            tiempo: ''
        }
    },
    components:{
        FilaAlumnos
    },
    created(){
            this.getCheckFiltros()
            this.getFiltros()
    },
    methods: {
        getFiltros(valor = false){
            let array = []
            this.programa.alumnos.forEach(a => {
                if(this.isSelected(a)){
                    array.push(a)
                }
            })
            this.alumnosFiltro = array
            if(valor){
                const obj = {
                    ciclo: this.posicion_ciclo,
                    programa: this.posicion_programa,
                    filtros: this.filtros,
                    filtro_texto: this.filtro_texto
                }
                this.$emit("filtrosModificados", obj)
            }
        },
        getCheckFiltros(){
            this.filtros = this.filtrosGenerales?.alumnosFiltro[this.posicion_ciclo]?.programas[this.posicion_programa]?.filtros.length ? this.filtrosGenerales?.alumnosFiltro[this.posicion_ciclo]?.programas[this.posicion_programa]?.filtros : this.filtros
            this.filtro_texto = this.filtrosGenerales?.alumnosFiltro[this.posicion_ciclo]?.programas[this.posicion_programa]?.filtro_texto != '' ? this.filtrosGenerales?.alumnosFiltro[this.posicion_ciclo]?.programas[this.posicion_programa]?.filtro_texto : this.filtro_texto
            if(!this.filtrosGenerales?.alumnosFiltro[this.posicion_ciclo]?.programas[this.posicion_programa]?.filtros.length){
                const obj = {
                    ciclo: this.posicion_ciclo,
                    programa: this.posicion_programa,
                    filtros: this.filtros,
                    filtro_texto: this.filtro_texto
                }
                this.$emit("filtrosVacios", obj)
            }
        },
        isSelected(alumno){
            let result = true
            this.filtros.forEach(i => {
                if(i.valor && !alumno[i.tipo]){
                    result = false
                    return false
                }
            })
            return result
        },
        getFiltrarTexto(texto){
            const filtrados = this.programa.alumnos.filter(word => this.isEqual(word, texto))
            this.alumnosFiltro = filtrados
            const vm = this
            clearTimeout(vm.tiempo)
            vm.tiempo = setTimeout(() => {
                this.getFiltros(true)
            }, 1000);
        },
        isEqual(word, texto){
            if(word.matricula.toUpperCase().includes(texto.toUpperCase()) || word.nombre.toUpperCase().includes(texto.toUpperCase()) || word.grado.toUpperCase().includes(texto.toUpperCase()) ){
                return true
            }
            return false
        }
    },
}
</script>